export const FETCH_PORTFOLIOS_INIT = 'FETCH_PORTFOLIOS_INIT'
export const FETCH_PORTFOLIOS_SUCCESS = 'FETCH_PORTFOLIOS_SUCCESS'
export const FETCH_PORTFOLIOS_FAILED = 'FETCH_PORTFOLIOS_FAILED'
